<template>
  <div
    v-if="afficherCatfish"
    id="catfish"
    :class="[
      jel_getClassObject(content),
      { 'top-shadow': content.catfishTopShadow, catfish: !mixinEnvironnement_inEditor },
      content.catfishTheme,
    ]"
    :style="{
      '--couleurBackground': content.catfishBackground,
    }"
  >
    <!-- :data-start-date="startDate" :data-end-date="endDate" -->
    <div class="d-block" :class="{ 'position-relative': !mixinEnvironnement_inEditor }">
      <span class="catfish-close" @click="fermerCatfish()">x</span>

      <b-link
        v-if="content.typeCatfish.field == 'catfishImage'"
        v-bind="jel_getLienBinding(content.lienCatfish)"
        :ga-img-name="
          $mq == 'xs' || $mq == 'sm'
            ? content.typeCatfish.imageMobile['@name']
            : content.typeCatfish.image['@name']
        "
      >
        <b-img-lazy
          :src="getImage()"
          :alt="content.texte"
          :class="content.typeCatfish.imgStyleFull == 'true' ? 'w-100' : 'mw-100'"
        />
      </b-link>
      <div v-else-if="content.typeCatfish.field == 'catfishHTML'" class="catfish-html">
        <b-link v-bind="jel_getLienBinding(content.lienCatfish)" class="catfish-lien">
          <div class="catfish-texte" v-html="content.typeCatfish.texteHTML" />
        </b-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mixinEnvironnement } from '@/mixins/mixinEnvironnement';

export default {
  name: 'Catfish',
  mixins: [mixinEnvironnement],
  props: { content: { type: Object, required: true } },
  data() {
    return {
      afficherCatfish: true,
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.jel_setCookieAffichage(this.content); // nextTick obligatoire
    });
  },
  methods: {
    getImage() {
      return this.$mq == 'xs' || this.$mq == 'sm'
        ? this.jel_getFichierSrc(this.content.typeCatfish.imageMobile)
        : this.jel_getFichierSrc(this.content.typeCatfish.image);
    },
    fermerCatfish() {
      this.afficherCatfish = !this.afficherCatfish;
      this.jel_setCookieAffichageFermeture(this.content);
    },
  },
};
</script>

<style lang="scss" scoped>
.catfish {
  position: fixed;
  text-align: center;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 99;
  overflow: hidden;
  background-color: var(--couleurBackground);
  &.top-shadow {
    box-shadow: 0px -2px 5px 0px rgba(255, 255, 255, 0.39);
  }
  &.light {
    .catfish-close {
      background: black;
      color: white;
      border-left: 1px solid #dddddd;
      border-bottom: 1px solid #dddddd;
    }
    .catfish-texte {
      color: #000000;
    }
  }

  &.dark {
    .catfish-close {
      background: white;
      color: black;
      border-left: 1px solid #000000;
      border-bottom: 1px solid #000000;
    }
    .catfish-texte {
      color: #ffffff;
    }
  }
}
.catfish-close {
  line-height: 0.6em;
  position: absolute;
  top: 0px;
  right: 0px;
  padding: 8px 10px 10px 9px;
  font-size: 24px;
  cursor: pointer;
}

.catfish-html {
  padding: 15px;
  width: 90%;
  margin: auto;
  ::v-deep p {
    margin-bottom: 0;
  }
}

.catfish-lien {
  text-decoration: none;
}
</style>
